import axios from 'axios'

const refreshAuthLogic = () =>
  axios.get('/sanctum/csrf-cookie').then(() => Promise.resolve())

export { refreshAuthLogic }
